export const DEFAULT_RESOURCE_STYLE = 0;

export const PLUS_RESOURCE_STYLE = 1;

export const NEGATIVE_RESOURCE_STYLE = 2;